import { render, staticRenderFns } from "./TestReportPage.vue?vue&type=template&id=67378429&scoped=true&"
import script from "./TestReportPage.vue?vue&type=script&lang=js&"
export * from "./TestReportPage.vue?vue&type=script&lang=js&"
import style0 from "./TestReportPage.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TestReportPage.vue?vue&type=style&index=1&id=67378429&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67378429",
  null
  
)

export default component.exports